// master namespace for the application
/** @namespace */
var veritracks = {};

if (typeof exports !== 'undefined') {
    module.exports = veritracks;
}